<template>
  <div class="storyBox" :class="[language == 'zh'?'zhFamily':'enfamily']">
    <!-- 暂未定模块 -->
    <div class="top_box">
      <div class="left_box">
        <div class="left_box_content">
          <div class="left_hr" :style="{ background: color_value }"></div>
          <div class="shape">
            <!-- <div class="triangle-left" :style="{'border-right':`10px solid ${color_value}`}"></div> -->
            <div class="rectangle" :style="{ background: color_value }">
              {{ $t("knowledgeBase.target") }}
            </div>
            <div
              class="triangle-right"
              :style="{
                'border-bottom': `20px solid ${color_value}`,
                'border-top': `20px solid ${color_value}`,
              }"
            ></div>
          </div>
          <div class="content_story">
            <div class="loading_" v-if="story.length == 0">
              <div class="loading" v-show="showLoading">
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
              </div>
            </div>

            <ul class>
              <li v-for="(item, index) in story.objectivesList" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right_box">
        <div class="right_box_content">
          <div class="left_hr" :style="{ background: color_value }"></div>
          <div class="shape">
            <!-- <div class="triangle-left" :style="{'border-right':`10px solid ${color_value}`}"></div> -->
            <div class="rectangle" :style="{ background: color_value }">
              {{ $t("knowledgeBase.progress") }}
            </div>
            <div
              class="triangle-right"
              :style="{
                'border-bottom': `20px solid ${color_value}`,
                'border-top': `20px solid ${color_value}`,
              }"
            ></div>
          </div>
          <div class="content_story">
            <div class="loading_" v-if="story.length == 0">
              <div class="loading" v-show="showLoading">
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
                <span :style="{ background: color_value }"></span>
              </div>
            </div>
            <ul class>
              <li v-for="(item, index) in story.progressList" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 图表模块 -->
    <div class="bottom_box">
      <div class="left_hr" :style="{ background: color_value }"></div>
      <div class="shape">
        <div
          class="triangle-left"
          :style="{ 'border-right': `10px solid ${color_value}` }"
        ></div>
        <div class="rectangle" :style="{ background: color_value }">
          {{ $t("knowledgeBase.goal") }}
        </div>
        <div
          class="triangle-right"
          :style="{
            'border-bottom': `20px solid ${color_value}`,
            'border-top': `20px solid ${color_value}`,
          }"
        ></div>
      </div>
      <!-- echars -->
      <div class="ecahrs_boxss">
        <div class="_300px">
          <div class="title__">{{ $t("knowledgeBase.indicator") }}:</div>
          <el-select v-model="indicator" @change="selectOne">
            <el-option
              v-for="item in indicatorArray"
              :key="item.indicator_name"
              :label="item.indicator_name"
              :value="item.indicator_name"
            />
          </el-select>
        </div>
        <div class="_300px">
          <div class="title__">{{ $t("knowledgeBase.series") }}:</div>
          <el-select v-model="series" @change="selectTwo">
            <el-option
              v-for="item in seriesArray"
              :key="item.series_code"
              :label="item.series"
              :value="item.series_code"
            />
          </el-select>
        </div>
        <div>
          <div class="title__">{{ $t("knowledgeBase.country") }}:</div>
          <div class="country_box" @click="country()">
            <!-- <input
            readonly="readonly"
            class="input_country"
            type="text"
            @click="country()"
            v-model="countryData.area"
            />-->
            <transition-group
              name="list"
              tag="div"
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
              "
            >
              <div
                class="select_country"
                v-for="(item, index) in checkList"
                :key="item"
              >
                <div>{{ item.split("-")[0] }}</div>
                <i
                  @click.stop="deleteCountry(index)"
                  class="iconfont icon-guanbi1"
                ></i>
              </div>
            </transition-group>
          </div>
        </div>
      </div>

      <div v-show="!noData" id="box" style="height: 450px; width: 100%"></div>
      <div v-show="noData" class="nodata">{{ noData }}</div>
      <div class="loading_">
        <div class="loading" v-show="showLoading">
          <span :style="{ background: color_value }"></span>
          <span :style="{ background: color_value }"></span>
          <span :style="{ background: color_value }"></span>
          <span :style="{ background: color_value }"></span>
          <span :style="{ background: color_value }"></span>
        </div>
      </div>
      <div class="popup" :class="[selectPanelValue ? 'isOpen' : 'isClose']">
        <div class="select_countrys">
          <div>{{ $t("knowledgeBase.selectCountry") }}</div>
          <div @click="closePopup()">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
        <div class="search_box">
          <div>
            <i class="iconfont icon-chaxun"></i>
          </div>
          <input type="text" placeholder="Search" @input="searchFn($event)" />
        </div>
        <ul class="letter_list">
          <li
            v-for="(item, index) in letter"
            :key="index"
            :style="{ color: color_value }"
            @click="
              selectLetter(
                language == 'zh' ? item.toLowerCase() : item.toUpperCase()
              )
            "
          >
            <div v-if="language == 'zh'">{{ item.toLowerCase() }}</div>
            <div v-else>{{ item.toUpperCase() }}</div>
          </li>
        </ul>
        <div class="search_result">
          <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="(item, index) in resultList"
              :key="item"
              :label="`${item.area}-${item.geoCode}`"
              >{{ item.area }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- <ul>
            <li
              :style="currentCountry == item?`color: ${color_value}` : `color: #333` "
              v-for="(item,index) in resultList"
              :key="index"
              @click="selectCountry(item)"
            >{{item.area}}</li>
          </ul>-->
        </div>
        <div class="submit">
          <div
            class="submit_btn"
            @click="submitBtn()"
            :style="{ background: color_value }"
          >
            {{ $t("knowledgeBase.confirm") }}
          </div>
        </div>
      </div>
    </div>
    <!-- 数据模块 -->

    <div class="link_box">
      <!-- <div :style="{'background':color_value}">链接</div> -->
      <ul>
        <li
          :style="{
            background: color_value,
            color: '#fff',
            padding: '5px 30px',
          }"
        >
          {{ $t("knowledgeBase.link") }}
        </li>
        <li v-for="(item, index) in story.linkList">
          <a
            :href="item.href"
            :style="{ color: color_value }"
            target="_blank"
            >{{ item.text }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  countryByAreaInitial,
  fuzzySearch,
  countryList,
  indicatorsByGoalId,
  series,
  echarsDimension,
  stroyDataByGoalId,
} from "@/axios/sdgDataBase.js";
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
//可以放入项目中的公共方法中进行调用
function debounce(func, wait = 500) {
  let timeout;
  return function (event) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.call(this, event);
    }, wait);
  };
}
export default {
  props: ["color_value"],
  name: "storyData",
  mixins: [mapMixin],
  data() {
    return {
      checkList: [],
      showLoading: true,
      myChart: null,
      noData: "",
      flag: 1,
      indicator: null,
      indicatorArray: [],
      seriesArray: [],
      series: [],
      resultList: [],
      currentCountry: "",
      letter: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      countryData: "",
      selectPanelValue: false,
      // language: "1",
      story: [
        // "全世界10%的人口,既7亿人生活在极端贫困中，每天的生活费不足190美元",
        // "有工作并不能保证体面的生活,实际上,2018年全球有8%的就业工人及其家庭生活在机端贫困中",
        // "在全球范围内,年龄在25至34岁之间的极端贫困人口男女比例为100:122"
      ],
    };
  },
  mounted() {
    // this.getCountryByArea("");
    bus.$on("openMenuFun1", (obj) => {
      this.story = [];
      this.showLoading = true;
      this.getStroyDataByGoalId(obj.id);
      this.getIndicatorsByGoalId(obj.id);
    });
  },
  methods: {
    deleteCountry(index) {
      this.checkList.splice(index, 1);
    },
    async getStroyDataByGoalId(id) {
      var res = await stroyDataByGoalId({ goal: id });
      this.story = res.data.data;
    },
    //   提交数据
    saveData() {
      this.getEcharsDimension();
    },
    // 获取指标体系
    async getIndicatorsByGoalId(id) {
      this.checkList = [];
      this.countryData = "";
      if (this.myChart) {
        this.myChart.clear();
      }
      var res = await indicatorsByGoalId(id);
      this.indicatorArray = res.data.data;
      this.indicator = this.indicatorArray[0].indicator_name;
      this.noData = "";
      this.getSeries(this.indicator);
    },
    // 根据指标获取系列
    async getSeries(indicator) {
      this.noData = "";
      var res = await series(indicator);
      this.seriesArray = res.data.data;
      this.series = this.seriesArray[0].series_code;
      this.getCountryList("").then(() => {
        this.getEcharsDimension();
      });
    },

    // 根据系列 指标  国家获取图表数据
    async getEcharsDimension() {
      var param = {
        seriesCode: this.series,
        indicatorName: this.indicator,
        geoCode: this.countryData,
      };
      var res = await echarsDimension(param);
      var echarsData = res.data.data;
      if (echarsData) {
        this.noData = "";
        setTimeout(() => {
          this.line(echarsData);
        }, 500);
      } else {
        this.showLoading = false;
        this.noData = this.$t("knowledgeBase.nodata");
      }
    },
    /* 折线图 */
    line(data) {
      if (this.myChart) {
        this.myChart.clear();
      }

      this.myChart = this.$echarts.init(document.getElementById("box"));

      var option = {
        title: {
          text: data.title,
          padding: 20,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: data.data.name,
          top: "50px",
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "50px",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: data.data.time,
        },
        yAxis: {
          type: "value",
        },
        series: data.data.data,
      };
      this.showLoading = false;
      this.myChart.setOption(option);
      this.myChart.hideLoading();
    },
    // 搜索功能
    searchFn: debounce(function (e) {
      this.showLoading = true;
      var val = e.target.value;
      this.getFuzzySearchCountry(val);
    }),
    selectLetter(item) {
      this.getCountryByAreaInitial(item);
    },
    // 提交
    submitBtn() {
      this.showLoading = true;
      var str = "";
      this.checkList.forEach((item) => {
        str += item.split("-")[1] + ",";
      });
      this.countryData = str;
      this.selectPanelValue = false;
      this.currentCountry = null;
      // item.split('-')[0]
      //  this.setCountryList(this.checkList);
      this.getEcharsDimension();
    },
    // 关闭
    closePopup() {
      this.selectPanelValue = false;
      this.currentCountry = null;
    },
    // 模糊搜索国家列表
    async getFuzzySearchCountry(val) {
      var param = {
        seriesCode: this.series,
        indicatorName: this.indicator,
        likeArea: val,
      };
      var res = await fuzzySearch(param);
      if (this.countryData == "") {
        this.countryData = res.data.data[0].geoCode;
      }
      this.resultList = res.data.data;
    },
    // 获取国家列表查询国家
    async getCountryByArea(val) {
      var param = {
        seriesCode: this.series,
        indicatorName: this.indicator,
        area: "",
      };
      var res = await countryByArea(param);
      if (this.countryData == "") {
        this.countryData = res.data.data[0].geoCode;
      }
      this.resultList = res.data.data;
    },
    // 根据国家名称字母获取对应国家
    async getCountryList() {
      var param = {
        seriesCode: this.series,
        indicatorName: this.indicator,
      };
      var res = await countryList(param);

      // console.log(res.data.data);
      this.resultList = res.data.data;
      if (this.countryData == "") {
        var a = res.data.data[0].area;
        var b = res.data.data[0].geoCode;

        this.checkList.push(`${a}-${b}`);
        this.countryData = this.checkList[0].split("-")[1];
      }
    },
    async getCountryByAreaInitial(letter) {
      var param = {
        seriesCode: this.series,
        indicatorName: this.indicator,
        areaInitial: letter,
      };
      var res = await countryByAreaInitial(param);
      this.resultList = res.data.data;
    },

    selectCountry(item) {
      this.currentCountry = item;
    },
    selectOne(val) {
      this.showLoading = true;
      this.getSeries(val);
    },
    selectTwo(val) {
      this.showLoading = true;
      this.series = val;
      this.getCountryList("").then(() => {
        this.getEcharsDimension();
      });
    },
    // 打开弹出层
    country() {
      this.selectPanelValue = !this.selectPanelValue;
    },
  },
  watch: {
    selectPanelValue(val, oldVal) {
      //普通的watch监听
      if (val) {
        // this.getCountryByAreaInitial("");
      }
    },
  },
};
</script>

<style lang="scss" >
.select_country:hover {
  cursor: pointer;
  background: #fff;
}
.select_country {
  background: #fff;
  // width: 150px;
  border: 1px solid rgba(0, 158, 219, 1);
  border-radius: 5px;
  padding: 2px 10px 2px 4px;
  margin: 2px;
  color: rgba(0, 158, 219, 1);
  min-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 8px;
  i {
    cursor: pointer;

    font-size: 14px;
    color: #ccc;
    transition: 0.1s;
  }
  i:hover {
    transition: 0.1s;
    color: rgba(0, 158, 219, 1);
  }
}
.nodat_ {
  text-align: center;
  color: #ccc;
  margin-top: 120px;
  font-size: 32px;
}
.currentColor {
  color: #000;
}
.popup {
  position: absolute;
  top: 80px;
  right: 30px;
  left: 30px;
  bottom: 10px;
  //   width: 300px;
  //   height: 500px;
  max-height: calc(100vh - 150px);
  background: rgba(255, 255, 255, 1);
  border: 1px solid #d8d8d8;
  padding: 10px 10px;
  box-shadow: 3px 3px 6px #999;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  .select_countrys {
    height: 30px;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 6px;
    display: flex;
    justify-content: space-between;
    i {
      color: #666;
    }
    i:hover {
      cursor: pointer;
      color: #d1d1d1;
    }
  }
  .search_box {
    width: 100%;
    height: 36px;
    margin-bottom: 5px;
    position: relative;
    i {
      position: absolute;
      left: 20px;
      font-size: 22px;
      color: #999;
      margin-top: 6px;
    }
    input {
      width: 100%;
      height: 36px;
      border-radius: 10px;
      border: 1px solid #ccc;
      text-indent: 50px;
      font-size: 16px;
    }
  }
  .letter_list {
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;
    li {
      font-size: 16px;
      padding: 0 10px;
    }
  }
  .search_result {
    flex: 1;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 10px;
    .el-checkbox-group {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      .el-checkbox {
        width: 50%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        // padding-right: 20px;
        margin-right: 0;
        line-height: 28px;
        // height: 24px;
        font-size: 16px;
        // padding-left: 10px;
        text-align: left;
      }
    }
  }
  // .search_result {
  //   flex: 1;
  //   overflow-y: auto;
  //   border: 1px solid #ccc;
  //   padding: 10px;
  //   ul {
  //     display: flex;
  //     flex-direction: row;
  //     justify-content: flex-start;
  //     flex-wrap: wrap;
  //     li {
  //       width: 50%;
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //       overflow: hidden;
  //       padding-right: 20px;
  //       line-height: 28px;
  //       // height: 24px;
  //       font-size: 16px;
  //       padding-left: 10px;
  //     }
  //     li:hover {
  //       background: #d9d9d9;
  //     }
  //   }
  // }
  .submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    width: 100%;
    .submit_btn {
      cursor: pointer;
      height: 36px;
      width: 70px;
      border-radius: 10px;
      text-align: center;
      color: #fff;
      line-height: 36px;
      transition: 0.2s;
    }
    .submit_btn:hover {
      opacity: 0.8;
      transition: 0.2s;
    }
  }
  .search_result::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
    scrollbar-arrow-color: red;
    cursor: pointer;
  }
  .search_result::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(193, 193, 193, 1);
    scrollbar-arrow-color: red;
  }
  .search_result::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
}
.isOpen {
  // right:-0px !important;
  right: 30px !important;
  transition: 0.2s all;
  transform-origin: 900px top;
  transform: scale(1) translateZ(0) !important;
}
.isClose {
  transform: scale(0) translateZ(0) !important;
  transition: 0.2s all;
  transform-origin: 700px top;
}
.loading_ {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -100px;
}
.ecahrs_boxss {
  // height: 32px;
  margin-left: 32px;
  margin-top: 10px;
  position: relative;
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;

  .title__ {
    min-width: 60px;
  }
  .input_country {
    height: 40px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    text-indent: 10px;
  }
  .ecahrs_boxss .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px !important;
    text-indent: 10px !important;
  }
  .el-input__icon {
    line-height: 32px !important;
  }
  ._300px {
    min-width: 250px;
  }
  > div {
    margin-right: 10px;
    display: flex;
    align-items: center;
    > div {
      margin-right: 10px;
    }
  }
  .btn_s:hover {
    opacity: 0.6;
    transition: 0.2s;
  }
  .btn_s {
    i {
      margin-right: 10px;
      font-size: 22px;
    }
    color: #fff;
    padding: 0px 20px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.2s;
  }
}
.shape {
  display: flex;
  height: 40px;
  .rectangle {
    height: 40px;
    // width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .triangle-left {
    /* 左三角 */
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    // border-right: 7.5px solid #f00;
  }
  .triangle-right {
    /* 左三角 */
    width: 0;
    height: 0;
    // border-top: 15px solid #f00;
    // border-bottom: 15px solid #f00;
    border-right: 10px solid transparent;
  }
}
.left_hr {
  width: 10px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
// 链接
.link_box {
  padding: 20px 0px;
  display: flex;
  align-items: center;
  div {
    height: 100%;
    padding: 5px 30px;
    color: #fff;
  }
  ul {
    box-sizing: content-box;
    flex: 1;
    border: 1px solid rgba(218, 218, 218, 1);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: rgba(238, 238, 238, 1);
    li {
      padding: 5px 10px;
      margin-right: 6px;
      a {
        color: #666;
        font-size: 16px;
      }
    }
  }
}
.storyBox {
  display: flex;
  flex-direction: column;
  .top_box {
    display: flex;
    flex-direction: row;
    height: 400px;
    .left_box {
      width: 50%;
      height: 100%;
      padding-right: 8px;
      .left_box_content {
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        background: rgba(243, 243, 243, 1);
        // padding: 10px;
        li {
          width: 100%;
          overflow: hidden;
        }
        .title {
          height: 34px;
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          width: 120px;
          margin: 0 auto;
        }
      }
    }
    .right_box {
      width: 50%;
      height: 100%;
      padding-left: 8px;
      position: relative;
      .right_box_content {
        height: 100%;
        width: 100%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        background: rgba(243, 243, 243, 1);
        // padding: 10px;
      }
    }
  }
  .bottom_box {
    margin-top: 20px;
    min-height: 500px;
    width: 100%;
    border-radius: 10px;
    position: relative;
    background: rgba(243, 243, 243, 1);
    display: flex;
    flex-direction: column;
  }
}
.nodata {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #ccc;
  margin-top: 160px;
}
.loading {
  width: 150px;
  height: 15px;
  margin: 0 auto;
  margin-top: 100px;
}
.loading span {
  display: inline-block;
  width: 15px;
  height: 100%;
  margin-right: 5px;
  border-radius: 50%;

  -webkit-animation: load 1.04s ease infinite;
}
.loading span:last-child {
  margin-right: 0px;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}
.loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}
.loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}
.loading span:nth-child(4) {
  -webkit-animation-delay: 0.52s;
}
.loading span:nth-child(5) {
  -webkit-animation-delay: 0.65s;
}
.content_story {
  flex: 1;
  overflow-y: auto;
  ul {
    // width: 100%;
    padding-top: 10px;
    height: 100%;
    overflow-y: auto;
    padding-left: 26px;
    li {
      margin-bottom: 10px;
      color: #666;
      font-size: 14px;
    }
  }
}
.content_story ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
  scrollbar-arrow-color: red;
  cursor: pointer;
}
.content_story ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  /* border-radius: 5px; */
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgb(202, 201, 201);
  scrollbar-arrow-color: red;
}
.content_story ul::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.loding_1 {
  position: absolute;
  left: 50%;
  top: 45%;
  margin-left: -30px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-30px);
}
.country_box {
  padding: 4px 0;
  flex: 1;
  margin-top: 10px;
  min-height: 40px;
  min-width: 200px;
  cursor: pointer;
  // width: 80%;
  border-radius: 5px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 0 40px 0 4px;
  text-indent: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;
  // overflow-y: auto;
  align-items: center;
}
</style>